var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSizesSelected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2563eb",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m17.104 2.895-3.665-1.222a3.347 3.347 0 0 1-6.693 0L3.081 2.895a1.67 1.67 0 0 0-1.12 1.866l.485 2.903a.84.84 0 0 0 .828.703h1.799v8.366c0 .92.753 1.674 1.673 1.674h6.693a1.673 1.673 0 0 0 1.674-1.674V8.367h1.799a.84.84 0 0 0 .828-.703l.485-2.903a1.67 1.67 0 0 0-1.121-1.866"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2563eb",
  d: "M19.349 23.48v2.178h-1.5V23.48h-2.962v2.178h-1.5V23.48h-2.962v2.178h-1.5V23.48H5.963v2.178h-1.5V23.48H1.5v2.178H0V21.98h19.436v1.5zM22.835.087h2.179v1.5h-2.179v2.962h2.179v1.5h-2.179V9.01h2.179v1.5h-2.179v2.962h2.179v1.5h-2.179v2.963h2.179v1.5h-3.679V0h1.5z"
})));
export default SvgSizesSelected;